<template>
    <span v-if="visibile && mostra" class="chip-login-wrap">{{ label }}</span>
</template>

<script>
import { SUPERADMIN_CODE } from '@/modules/utilities.js'

const MAI = 2147483647; // int.MaxValue
const SOGLIA = 30;

export default {
    name: 'ChipLoginOratore',
    props: {
        oratore: { type: Object, default: null },
    },
    computed: {
        visibile() {
            const o = this.$store.state.oratore;
            if (!o) return false;
            return o.codice == SUPERADMIN_CODE || o.isAdmin;
        },
        giorniApp() {
            return this.oratore?.giorniDaLogin ?? this.oratore?.GiorniDaLogin ?? MAI;
        },
        giorniWeb() {
            return this.oratore?.giorniDaLoginWeb ?? this.oratore?.GiorniDaLoginWeb ?? MAI;
        },
        mostra() {
            // mostra solo se almeno uno dei due è ≤ soglia
            return this.giorniApp <= SOGLIA || this.giorniWeb <= SOGLIA;
        },
        labelApp() {
            return this.giorniApp <= SOGLIA ? String(this.giorniApp) : '-';
        },
        labelWeb() {
            return this.giorniWeb <= SOGLIA ? String(this.giorniWeb) : '-';
        },
        label() {
            return `${this.labelApp}/${this.labelWeb}`;
        },
    },
}
</script>

<style scoped>
.chip-login-wrap {
    font-size: 0.68rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 8px;
    background-color: rgba(25, 118, 210, 0.1);
    color: #1976d2;
}
.theme--dark .chip-login-wrap {
    background-color: rgba(144, 202, 249, 0.15);
    color: #90caf9;
}
</style>
